/**
 * URLs that used to work, and still have to.
 *
 * <h3>Why this is data and not inline routes</h3>
 *
 * A bookmark somebody saved a year ago is a promise. These were written inline
 * in the route table where nothing could check them, so a rename could leave
 * one pointing at a path that no longer exists and nobody would know until a
 * customer followed a link into the dashboard.
 *
 * <h3>One hop, never a chain</h3>
 *
 * Every alias points at a real route, not at another alias. A chain costs an
 * extra render and history entry for no reason, and it is how a redirect loop
 * begins. The test beside this file refuses a chain.
 *
 * <h3>What this costs at run time</h3>
 *
 * Nothing on the server. These resolve inside the router that is already
 * running: one in-memory history replace and one render, for the people
 * arriving on an old link only.
 */
export const ROUTE_ALIASES = [
  { from: 'skill-center', to: '/skills' },
  /* The hub was called Governance until the product settled on Protect. Both
     of its old names still arrive from bookmarks and from links sent in
     email, and both land in one hop. */
  { from: 'governance-hub', to: '/protection-hub' },
  { from: 'governance-center', to: '/protection-hub' },
  { from: 'audit-trail', to: '/workflow-audit' },
  { from: 'workflows', to: '/canvas' },
  { from: 'gel-registrations', to: '/agents?type=ExteLet' },
  { from: 'registrations', to: '/agents?type=ExteLet' },
];

/** Where an old path goes, or null when it is not an alias. */
export function aliasTargets(from) {
  return ROUTE_ALIASES.find((a) => a.from === from)?.to ?? null;
}
